<template>
    <NuxtLink
        class="news-card border-news flex flex-col overflow-hidden rounded-3xl bg-base-white shadow-custom"
        :to="$localePath(`/awards/${award?.id}`)"
        v-if="shouldRender(award?.id)"
        v-sendGAsignal="{
            event_category: route.path.includes('about')
                ? 'about.awards'
                : 'awards',
            event_label: `${award?.id}-${award?.meta_box?.article?.headline}`,
        }"
    >
        <div
            class="relative w-full overflow-hidden rounded-b-[.5rem] rounded-t-3xl pb-[55.4%] sm:pb-[63.9%] lg:rounded-3xl lg:pb-[76%]"
        >
            <AtomsResponsiveImg
                v-if="award?.featured_media"
                :src="{
                    lg: award?.featured_media?.url,
                }"
                :alt="award?.featured_media?.alt"
                :width="award?.featured_media?.media_details?.width"
                :height="award?.featured_media?.media_details?.height"
                class="absolute inset-0 h-full w-full object-cover"
            />
        </div>

        <div
            class="relative flex flex-col gap-2 px-4 pb-[72px] pt-4 lg:gap-6 lg:px-8 lg:pb-[80px] lg:pt-6"
        >
            <AtomsH3
                class="line-clamp-3 text-left text-base-black"
                v-if="shouldRender(award?.meta_box?.customTitle)"
            >
                {{ renderLines(award?.meta_box?.customTitle) }}
            </AtomsH3>
            <AtomsH5
                class="line-clamp-3 text-left text-base-black/60"
                v-if="shouldRender(award?.meta_box?.customDescription)"
            >
                {{ renderLines(award?.meta_box?.customDescription) }}
            </AtomsH5>
            <!-- <SvgArrowForward24
                class="absolute bottom-4 right-4 !h-6 !w-6 lg:hidden"
            />
            <SvgArrowForward40
                class="absolute bottom-4 right-4 hidden !h-10 !w-10 lg:block"
            /> -->
            <div
                class="absolute bottom-4 right-4 h-[6.1vw] w-[6.1vw] self-end overflow-hidden xs:h-[24px] xs:w-[24px] lg:h-[1.59vw] lg:w-[1.59vw] 3xl:h-[30.5px] 3xl:w-[30.5px]"
            >
                <SvgArrowForward24
                    class="btn__arrow btn__arrow--main h-full w-full"
                />
                <SvgArrowForward24
                    class="btn__arrow btn__arrow--hover h-full w-full"
                />
            </div>
        </div>
    </NuxtLink>
</template>

<script setup>
import { renderLines, shouldRender } from "~/lib/utils";

const { award } = defineProps({
    award: {
        type: Object,
        required: true,
    },
});

const route = useRoute();
</script>

<style scoped>
.btn__arrow {
    @apply absolute right-0 top-0;
    transition:
        transform 0.3s cubic-bezier(0.17, 0.67, 0.3, 1.33),
        opacity 0.3s cubic-bezier(0.17, 0.67, 0.3, 1.33);
}

.btn__arrow--hover {
    transform: translate3d(-100%, 0, 0);
}
.news-card {
    transition: transform 0.3s cubic-bezier(0.17, 0.67, 0.3, 1.33);
}
.news-card > * {
    transition: transform 0.3s cubic-bezier(0.17, 0.67, 0.3, 1.33);
}

@media (hover: hover) and (pointer: fine) {
    .news-card:hover {
        @apply scale-105;
    }

    .news-card:hover > * {
        @apply scale-[0.9524];
    }

    .news-card:hover .btn__arrow--hover {
        transform: translate3d(0, 0, 0);
    }

    .news-card:hover .btn__arrow--main {
        transform: translate3d(100%, 0, 0);
    }

    .news-card:hover .btn__arrow--hover {
        transform: translate3d(0, 0, 0);
    }
}
</style>
